import { CONTEXT_URL_PARAMS } from '@/features/utils';
import { ANALYSIS_URL_PARAM } from '@/hooks/useAnalysisParam';

const ANALYTICS_URL_PARAMS = [
  ...CONTEXT_URL_PARAMS,
  ANALYSIS_URL_PARAM,
  'plan_id',
  'scenario',
  'level',
  'sort',
];

const ANALYTICS_URL_LIST_PARAMS = ['district', 'circuit'];

export const getUrlProperties = (
  search: string
): Record<string, string | string[]> => {
  const params = new URLSearchParams(search);
  return Object.fromEntries([
    ...ANALYTICS_URL_PARAMS.flatMap((key) => {
      const value = params.get(key)?.trim();
      return value ? [[key, value]] : [];
    }),
    ...ANALYTICS_URL_LIST_PARAMS.flatMap((key) => {
      const values = params.getAll(key);
      return values.length > 0 ? [[key, values]] : [];
    }),
  ]);
};
